import { globalDeleteService, globalGetService, globalPostService } from "../../../utils/globalApiServices";
import { permissionCheckFnforCamo } from "../../../utils";
import { trackActivity } from "../../../utils/mixpanel";
import { downloadFileType } from "../../../utils";
import { globalExportService } from "../../../utils/globalApiServices";

export function addModsFormApi(data, props) {
	if (
		permissionCheckFnforCamo({
			primaryKey: "mod_status",
			keyIndex: "C",
		})
	) {
		return new Promise(function (resolve, reject) {
			globalPostService(`camo/mods/create/`, data).then((response) => {
				if (response.status === 500) {
					props.enqueueSnackbar("Something went wrong.", {
						variant: "error",
						anchorOrigin: { vertical: "top", horizontal: "right" },
					});
				} else {
					resolve(response);
				}
			});
		});
	}
}

export function fillModsEditFormApi(item, props) {
	return new Promise(function (resolve, reject) {
		globalGetService(`camo/mods/view/${item.id}/`).then((response) => {
			if (response.status === 500) {
				props.enqueueSnackbar("Something went wrong.", {
					variant: "error",
					anchorOrigin: { vertical: "top", horizontal: "right" },
				});
			} else {
				resolve(response);
			}
		});
	});
}

export function deleteModsAttachment(id, props) {
	globalDeleteService(`camo/attachment/${id}/delete/`).then((response) => {
		if (response.status === 500) {
			props.enqueueSnackbar("Something went wrong.", {
				variant: "error",
				anchorOrigin: { vertical: "top", horizontal: "right" },
			});
		} else {
			if (response) {
				props.enqueueSnackbar("Attachment Deleted Successfully", {
					variant: "success",
					anchorOrigin: { vertical: "top", horizontal: "right" },
				});
				trackActivity("CAMO", { event_type: "Attachment Deleted", page_title: "Mods", item_id: id });
			}
		}
	});
}

export function DownloadModsSampleFile(queryParams = {}, props = {}) {
	globalExportService(`camo/mods/sample-file/`).then((response) => {
		if (response.status === 500) {
			props.enqueueSnackbar("Something went wrong.", {
				variant: "error",
				anchorOrigin: { vertical: "top", horizontal: "right" },
			});
		} else {
			downloadFileType(response.data, `SampleFile_MOD`, queryParams.download);
			trackActivity("CAMO", { event_type: 'Sample File Downloaded', page_title: "Mods", extension: queryParams.download });
		}
	});
}
